import { useState, useEffect } from "react";
import { getMatch } from "../services/matchService";
import { useNavContext } from "../context/nav_context";

const useMatch = (matchId) => {
  const { accessToken } = useNavContext();
  const [match, setMatch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!matchId) return;

    let cancelled = false;

    const loadMatch = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await getMatch(matchId, accessToken);
        if (!cancelled) {
          setMatch(data);
        }
      } catch {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadMatch();

    return () => {
      cancelled = true;
    };
  }, [matchId, accessToken]);

  return { match, loading, error };
};

export default useMatch;
